const firebase = require("firebase/app");
require("firebase/auth");
require("firebase/database");

const state = {
  likes: []
};

const mutations = {
  SET_LIKES(state, value) {
    state.likes = value;
  }
};

const getters = {
  getLikes: state => {
    return state.likes;
  }
};

const actions = {
  fetchLikes({ commit }) {
    if (firebase.auth().currentUser) {
      var likesRef = firebase
        .database()
        .ref("likes/" + firebase.auth().currentUser.uid);

      likesRef.on("value", function(snapshot) {
        if (snapshot.val()) {
          commit("SET_LIKES", snapshot.val().user_likes);
        } else {
          commit("SET_LIKES", []);
        }
      });
    }
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
